import React from "react";

export default function CriticalOverlay({ visible=false, message="", onClose=()=>{} }){
  if (!visible) return null;
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl p-6 max-w-md w-full space-y-4">
        <div className="text-lg font-semibold text-red-600">Kritischer Hinweis</div>
        <div className="text-sm">{message || "Bitte prüfen Sie die aktuellen Trades / Limits."}</div>
        <div className="flex justify-end gap-2">
          <button className="btn btn-muted" onClick={onClose}>Schließen</button>
        </div>
      </div>
    </div>
  );
}